// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-invalid[data-v-57170ede] {\n    border: 1px solid #dc3545;\n}\n.form-valid[data-v-57170ede] {\n    border: 1px solid var(--green-color);\n}\n", ""]);
// Exports
module.exports = exports;
